import { render, staticRenderFns } from "./IsPrimary.vue?vue&type=template&id=44640d02"
import script from "./IsPrimary.vue?vue&type=script&lang=js"
export * from "./IsPrimary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports